import { render, staticRenderFns } from "./TableMaterials.vue?vue&type=template&id=3986606b&scoped=true&"
import script from "./TableMaterials.vue?vue&type=script&lang=js&"
export * from "./TableMaterials.vue?vue&type=script&lang=js&"
import style0 from "./TableMaterials.vue?vue&type=style&index=0&id=3986606b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986606b",
  null
  
)

export default component.exports